import React from "react";
import "../styles/footer.css";

const Footer = () => {
  return (
    <footer className="custom-footer text-white" dir="rtl">
      <div className="container py-4">
        <div className="row">
          <div className="col-md-8 mb-3 text-justify">
            <h5 className=" mb-3">پژوهشکده فناوری رهینو</h5>
            <div class="divider-fade2"/>
            <p>
              در شرایط کنونی جهان، پیشرفت در علم و فناوری به‌عنوان محرک توسعه همه‌جانبه محسوب می‌شود به‌طوری که اگر کشوری بخواهد از عقب‌ماندگی فاصله بگیرد، باید به علم و فناوری اهتمام خاص داشته باشد.
              از الزامات سیاست‌گذاری موفق، اشراف به وضعیت کنونی علم و فناوری و رصد دائمی آن در داخل کشور و دیگر کشورهاست؛ به‌طوری‌که این رصدخانه علم و فناوری، توانایی لازم حرکت علم و فناوری از وضع موجود به وضع مطلوب را فراهم می‌آورد.
            </p>
          </div>
          <div className="col-md-4 mb-3 text-center text-md-start">
            <h5 className=" mb-3">پشتیبانی</h5>
            <p className="mb-0">rahino.observatory@gmail.com</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;